var header = {
    mobileMenuEntries: [],
    mobileChildMenus: [],
    menuIsOpen: false,

    initMegaMenu: function() {
        header.mobileMenuEntries = document.querySelectorAll('*[data-mobile-page-id]');
        header.mobileChildMenus = document.querySelectorAll('*[data-mobile-page-id-target]');

        for (let i=0; i<header.mobileMenuEntries.length; i++) {
            header.mobileMenuEntries[i].addEventListener('click', header.openMobileChildMenu);
        }
    },

    openMobileChildMenu: function(ev) {
        const targetPageId = ev.srcElement.getAttribute('data-mobile-page-id');
        document.querySelector('*[data-mobile-level="1"]').classList.add('hidden');
        document.querySelector('*[data-mobile-level="2"]').classList.remove('hidden');

        for (let i=0; i<header.mobileChildMenus.length; i++) {
            if (header.mobileChildMenus[i].getAttribute('data-mobile-page-id-target') === targetPageId) {
                header.mobileChildMenus[i].classList.remove('hidden');
                continue;
            }

            header.mobileChildMenus[i].classList.add('hidden');
        }
    },

    moveBackToFirstMobileStep: function() {
        document.querySelector('*[data-mobile-level="1"]').classList.remove('hidden');
        document.querySelector('*[data-mobile-level="2"]').classList.add('hidden');
    },

    moveBackToSecondMobileStep: function() {
        document.querySelector('*[data-mobile-level="2"]').classList.remove('hidden');
        document.querySelector('*[data-mobile-level="3"]').classList.add('hidden');
    },
}

window.addEventListener('DOMContentLoaded', header.initMegaMenu);